import React, { useState } from "react";
import "./index.css";

import { endImpersonation } from "../../api-requests/user";

export default ({ candidateName }) => {

    const [returning, setReturning] = useState(false);

    const handleReturn = () => {
        if (returning) return;
        setReturning(true);
        endImpersonation()
            .then(() => {
                window.location.assign("/");
            })
            .catch(() => setReturning(false));
    };

    return (
        <div className="impersonation-banner" role="status" aria-live="polite">
            <div className="impersonation-banner-inner">
                <span className="impersonation-banner-dot" aria-hidden="true" />
                <p className="impersonation-banner-text">
                    Signed in as <strong>{candidateName}</strong> from your admin account.
                </p>
                <button
                    type="button"
                    className="impersonation-banner-button"
                    onClick={handleReturn}
                    disabled={returning}
                >
                    {returning ? "Returning…" : "Return to admin"}
                </button>
            </div>
        </div>
    );

};
